<template>
	<dl :class="{'im-section': true, 'conversation-list-container': true, 'pt34': currentShop.id == -1}">
		<dt class="search-conversation">
			<searchConversation ref="searchConversation"></searchConversation>
		</dt>
		<dt v-if="currentShop.id != -1" class="conversation-type">
			<a href="javascript:;" :class="{active: !$store.state.conversationType}" @click="switchConversationType('')">当前会话</a>
			<a href="javascript:;" :class="{active: $store.state.conversationType === '1'}" @click="switchConversationType('1')">历史会话</a>
			<a href="javascript:;" :class="{active: $store.state.conversationType === '2'}" @click="switchConversationType('2')">标星会话</a>
		</dt>
		<dd :class="{'pt-none': currentShop.id == -1}">
			<conversationHead v-if="currentShop.id != -1" @changeSort="val => sortType = val" :sortType="sortType"></conversationHead>

			<conversationList :sortType="sortType" ref="conversationList"></conversationList>
			
			<conversationFooter></conversationFooter>
		</dd>
	</dl>
</template>

<script>
import searchConversation from './searchConversation.vue'
import conversationHead from './conversationHead.vue'
import conversationList from './conversationList.vue'
import conversationFooter from './conversationFooter.vue'
import bus from '@/config/eventBus'
export default {
	name: 'conversationContainer',
	components: { searchConversation, conversationHead, conversationList, conversationFooter },
	data () {
		return {
			sortType: 'startTime'
		}
	},
	computed: {
		currentShop () {
			return this.$store.state.currentShop;
		}
	},
	watch: {
		currentShop: {
			deep: true,
			handler (now, old) {
				if (now.id == old.id || !now.id) return;
				if (now.id == -1) {
					this.switchOfflineMsg();
				} else {
					this.$store.state.autoSelectedSession ? this.$store.commit('changeAutoSelectedSession', false) : this.switchConversationType('');
				}
			}
		},
		sortType (val) {
			window.sortType = val;
		}
	},
	mounted () {
		if (localStorage.getItem('IMSort')) this.sortType = localStorage.getItem('IMSort');
		window.sortType = this.sortType;
		bus.$on('bus_updateConversationList', (callback) => {
			this.switchConversationType(this.$store.state.conversationType, callback)
		})
	},
	methods: {
		// 切换到离线消息
		switchOfflineMsg () {
			var self = this;
			self.$store.commit('changeConversationList', []);
			self.$refs.searchConversation.selectShopId = self.$store.state.shopList.length ? self.$store.state.shopList[0].id : null;
			self.$refs.searchConversation.selectShopFun(self.$refs.searchConversation.selectShopId);
		},

		// 切换会话类型(当前会话/历史会话)
		switchConversationType (type, callback) {
			let self = this,
				data = {
					serviceType: this.currentShop.serviceType,
					shopId: this.currentShop.id,
					sessionOrder: this.sortType == 'startTime' ? 'asc' : 'desc',
					sortBy: this.sortType
				};

			if (!type) {
				data.closed = 0
				data.uncloseable = false
			} else if (type === '1') {
				data.uncloseable = false
				data.closed = 1
			} else if (type === '2') {
				data.uncloseable = true
			}

			if (this.$store.state.conversationType != type) {
				this.$store.commit('changeConversationType', type);
				this.$store.commit('changeConversationLoadStatus', true);
				this.$store.commit('changeConversationList', []);
			}

			TJ_DB.get(TJ_DB.C_Table, "'shopId' == " + data.shopId, (arr) => {
				if (!type && arr.filter(o => !o.uncloseable).length) {
					this.$store.commit('changeConversationList', arr.filter(o => !o.uncloseable));
					this.$store.commit('changeConversationLoadStatus', false);
					callback && (typeof callback === 'function') && callback()
				} else {
					get(arr);
				}
			})

			function get (arr) {
				self.$axios.post(API_ROOT.url + '/SessionApi.getSessionList', data).then(result => {
					if (data.shopId != self.currentShop.id || type != self.$store.state.conversationType) return;
					
					self.$store.commit('changeConversationLoadStatus', false);

					if (!result.status) {
						self.$alert('获取会话列表失败，失败原因：' + result.msg);
						return
					}

					let addData = result.data.filter(o => !o.closed && !arr.find(s => s.id == o.id))
					TJ_DB.add(TJ_DB.C_Table, addData, (dbres) => {
						if (dbres.error) {
							self.$message.error('10001: 本地数据库写入失败，请联系管理员')
						}
						let list = result.data.map(o => arr.find(s => s.id == o.id) || o)
						self.$store.commit('changeConversationList', list)
						callback && (typeof callback === 'function') && callback()
					});
				}, response => {
					self.$alert('获取会话列表失败，错误码(' + response + ')');
					self.$store.commit('changeConversationLoadStatus', false);
				})
			}
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/pages/conversation/conversationContainer.vue